module.exports = __webpack_public_path__ + "6ecff83cdd4c414978c29824a87182a8.png";